var template = (function() {
"use strict";

	// Privates
	var i = 10;


	// Public
	return {
		init: function() {


		},
		getIndex: function() {
			return i;
		}
	};
})();
template.init();